// Inspired from https://github.com/akserg/ng2-toasty
// Copyright (C) 2016 Sergey Akopkokhyants
// This project is licensed under the terms of the MIT license.

import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClarityModule } from '@clr/angular';

export * from './toast.service';
export * from './toast-container.component';

import { ToastContainerComponent } from './toast-container.component';
import { ToastComponent } from './toast.component';
import { ToastService, ToastConfig, ToastServiceFactory } from './toast.service';

export let providers = [
    ToastConfig,
    { provide: ToastService, useFactory: ToastServiceFactory, deps: [ToastConfig] }
];

@NgModule({
    imports: [CommonModule, ClarityModule.forRoot()],
    declarations: [ToastComponent, ToastContainerComponent],
    exports: [ ToastComponent, ToastContainerComponent],
    providers: providers
})
export class ToastModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: ToastModule,
            providers: providers
        };
    }
}



// WEBPACK FOOTER //
// ./src/common/toasts/index.ts